import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Alert from '../../../../UI/Alert'

/*
 * Hinweis über einem bereits eingereichten Bericht.
 *
 * Eingereichte Berichte sperrt das Backend: Jeder Speicherversuch endete mit
 * "Report was submited" (HTTP 404), während die Ansicht weiterhin wie ein
 * bearbeitbares Formular aussah (Anforderung #80). Die Felder bleiben lesbar,
 * die Schaltflächen zum Anlegen und Löschen entfallen, und dieser Hinweis sagt,
 * warum nichts mehr geht und wer es zurücksetzen kann.
 */
export default function SubmittedNotice({ isSubmitted }) {
	const { t } = useTranslation()

	if (!isSubmitted) return null

	return (
		<div style={{ margin: '0 48px 20px 38px' }}>
			<Alert style={{ maxWidth: '100%' }}>
				{t(
					'This report has been submitted and can no longer be edited. If something needs to be corrected, the administration can reset it.'
				)}
			</Alert>
		</div>
	)
}

SubmittedNotice.propTypes = {
	isSubmitted: PropTypes.bool
}
